import {Button} from "@/components/ui/button.tsx";
import {cn} from "@/lib/utils.ts";
import * as React from "react";


export type SaveState = "idle" | "saving" | "success" | "error";


export default function SaveButton(
    {saveState, className, type = "submit", disabled, ...props}: { saveState: SaveState } & React.ComponentProps<"button">
) {
    return (
        <Button type={type} size="sm" {...props}
                disabled={disabled || saveState === "saving"}
                className={cn(
                    "transition-colors duration-300 w-30",
                    saveState === "saving" && "opacity-50 cursor-wait",
                    saveState === "success" && "border-success/70 bg-success text-success-foreground hover:bg-success/85 shadow-md shadow-success/20",
                    saveState === "error" && "border-destructive/70 bg-destructive text-white hover:bg-destructive/85 shadow-md shadow-destructive/20",
                    className
                )}>
            {saveState === "saving" && "Speichern…"}
            {saveState === "success" && "Gespeichert"}
            {saveState === "idle" && "Speichern"}
            {saveState === "error" && "Fehler"}
        </Button>
    )
}
